<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JtfTxE/tc-custom/9781429906449.jpg?1730584700062" alt="This image is the cover for the book Comma Sense"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Comma Sense
      </h1>
      <p class="bookDescription body article font2">
        <b>“A clear, entertaining, and just plain helpful guide to the American rules of punctuation.” —Lynne Truss, #1 <i>New York Times</i>–bestselling author of <i>Eats, Shoots &amp; Leaves</i></b><br/><br/>Are you confounded by commas, addled by apostrophes, or queasy about quotation marks? Do you believe a bracket is just a support for a wall shelf, a dash is something you make for the bathroom, and a colon and semicolon are large and small intestines? If so, language humorists Richard Lederer and John Shore (with the sprightly aid of illustrator Jim McLean), have written the perfect book to help make your written words perfectly precise and punctuationally profound.<br/><br/>With buoyant wit and erudition, <i>Comma Sense</i> reveals the power and importance of each mark of punctuation. Lederer and Shore demonstrate what each has in common with a great American icon: the underrated yet powerful period with Seabiscuit; the jazzy semicolon with Duke Ellington; even the rebel apostrophe with famed outlaw Jesse James. When you’ve finished <i>Comma Sense, </i>you’ll not only have mastered everything you need to know about punctuation, you’ll have had fun doing so.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Lederer, John Shore
      </h2>
      
      <p class="authorDescription body article"><P><B>Richard Lederer, Ph.D.,</B> is the author of more than thirty books on the English language, including <I>Anguished English</I> and <I>A Man of My Words</I>. His syndicated column, "Looking at Language," appears in newspapers and magazines nationwide, and he co-hosts a weekly show on San Diego Public Radio. He lives in San Diego, California, with his wife. <br><br><B>John Shore</B> is a magazine writer and editor in San Diego. He is the author of <I>Penguins, Pain, & The Whole Shebang: Why I Do The Things I Do,</I> by God (as told to John Shore).</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Comma Sense
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?031c8682